import { get, post } from '../Services/http';
import { ExtapiInvoiceSearchQueryParams } from '../Types/MyPages/InvoicesModel';

const rootRoute = '/api/mypages/invoices';

export const getOrders = (queryParams) => {
  return post(`${rootRoute}/Orders`, queryParams).then((response) =>
    response.json()
  );
};

export const getOrder = (orderId) => {
  return get(`${rootRoute}/Order/${orderId}`).then((response) =>
    response.json()
  );
};

export const getInvoiceHeaders = (
  queryParams: ExtapiInvoiceSearchQueryParams | undefined,
  abortController: AbortController | undefined = undefined
) => {
  return post(
    `${rootRoute}/InvoiceHeaders`,
    queryParams,
    abortController
  ).then((response) => response.json());
};

export const getInvoiceHead = (invoiceId) => {
  return get(`${rootRoute}/Invoices/${invoiceId}`).then((response) =>
    response.json()
  );
};

export const getInvoiceRows = (invoiceId) => {
  return get(`${rootRoute}/InvoiceRows/${invoiceId}`).then((response) =>
    response.json()
  );
};

export const getInvoicePdf = (invoiceId) => {
  return get(`${rootRoute}/pdf/${invoiceId}`).then((response) =>
    response.blob()
  );
};

export const getReturnInvoiceRows = (invoiceId) => {
  return get(`${rootRoute}/OrderLines?invoiceId=${invoiceId}`).then(
    (response) => response.json()
  );
};

export const sendReturnInvoicesRequest = (data) => {
  return post(`${rootRoute}/sendreturninvoicesrequest`, data);
};

export const getInvoiceData = (invoiceNumber) => {
  return get(`${rootRoute}/getinvoicedata/${invoiceNumber}`).then(
    (response) => response.json()
  );
};

export const getConsignorData = (orderNumber, invoiceDate) => {
  return get(
    `${rootRoute}/getshipmentdata/${orderNumber}/${invoiceDate}`
  ).then((response) => response.json());
};
